import { useMemo } from 'react';
import { queryParams } from '@shared/commonFunctions';
import { LocalTabs } from '@shared/tabs/LocalTabs';
import { Comments } from './Comments';

export const CommentsTabs = () => {
	const params = queryParams();
	const defaultActiveTab = useMemo(() => params?.tab == 3 ? 1 : 0, [params]);

	const tabs = useMemo(
		() => [
			{
				name: 'Lead Comments',
				component: <Comments dealId={params.dealId} contactId={params.id} />,
			},
			{
				name: 'Deal Comments',
				component: <Comments isDeal contactId={params.id} dealId={params.dealId} />,
			}
		],
		[params.dealId, params.id]
	);

	const tabsData = useMemo(() => ((params.tab == 3 && params.dealId) ? tabs : [tabs[0]]), [params, tabs]);

	return (
		<LocalTabs
			hideShadow
			defaultActiveTab={defaultActiveTab}
			data={tabsData}
		/>
	);
};
